import { useState, useEffect, useCallback } from 'react';
import isStaffUserId from '@medflex/utils/isStaffUserId';
import Logger from '@medflex/utils/Logger';
import useUserProfile from './useUserProfile';
import useStaff from './useStaff';

const useHubspotChat = () => {
  const { userProfile, identifyHubspotUser } = useUserProfile();
  const { staff } = useStaff();
  const [isReady, setIsReady] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const onConversationsAPIReady = useCallback(async () => {
    if (!isReady) {
      try {
        const identificationEmail = isStaffUserId(userProfile?.id)
          ? staff?.find(s => s.id === userProfile.attributes.physicianUserId)?.email
          : userProfile.attributes?.email;

        if (!identificationEmail) return;

        const identificationToken = await identifyHubspotUser();

        window.hsConversationsSettings = {
          ...window.hsConversationsSettings,
          identificationEmail,
          identificationToken,
        };

        if (!isLoaded) {
          window.HubSpotConversations.widget.load();
        }

        window.HubSpotConversations.on('unreadConversationCountChanged', payload => {
          setUnreadCount(payload.unreadCount);
        });

        setIsReady(true);
      } catch (error) {
        Logger.error('Error identifying HubSpot user:', error);
        setIsReady(false);
      }
    }
  }, [identifyHubspotUser, isReady, staff, userProfile, isLoaded]);

  useEffect(() => {
    if (window.HubSpotConversations && !isReady) {
      onConversationsAPIReady();
    }
  }, [onConversationsAPIReady, isReady]);

  window.HubSpotConversations?.on('widgetLoaded', () => {
    if (!isLoaded) setIsLoaded(true);
  });

  return {
    isReady,
    isLoaded,
    unreadCount,
    onConversationsAPIReady,
    HubSpotConversations: window.HubSpotConversations || null,
    hsConversationsSettings: window.hsConversationsSettings,
  };
};

export default useHubspotChat;
